import { Controller } from "@hotwired/stimulus"

// Salto directo a página N en el paginador V2 (E6, decisión D7 del plan
// canónico: "ir directo a la página tanto… el mismo funcionamiento que la URL,
// pero bonito", 00:46:41). Un input numérico junto al paginador navega a la
// página pedida PRESERVANDO los filtros: el template de URL lo arma el
// componente en el server a partir del mismo `page_url` que usan los links de
// la serie — que ya trae los query params de la vista — con el token ":page:"
// donde va el número. Acá solo se sustituye y se visita.
//
// La validación 1..páginas vive dos veces: en los atributos min/max del input
// (nativo, sin JS) y en el clamp de abajo, que cubre lo tecleado a mano. Sin
// número legible, no navega: mejor ignorar que aterrizar en la página 1 de
// sorpresa.
export default class extends Controller {
  static targets = ["input"]
  static values = { pageTemplate: String }

  go(event) {
    event.preventDefault()

    const input = this.inputTarget
    const page = Number.parseInt(input.value, 10)
    if (Number.isNaN(page)) return

    const target = Math.min(Number.parseInt(input.max, 10),
                            Math.max(Number.parseInt(input.min, 10), page))
    input.value = target

    // Turbo expone su API en window.Turbo (mismo criterio que
    // auto_refresh_controller): una visita de Turbo, no un reload.
    window.Turbo.visit(this.urlFor(target))
  }

  // El server puede entregar el token crudo (page_url arma "?page=…" a mano)
  // o percent-encoded (url_for(page: ":page:") codifica los ":"). Cubrir ambos.
  urlFor(page) {
    const token = ":page:"
    const encoded = encodeURIComponent(token)
    const template = this.pageTemplateValue

    return template.includes(encoded) ? template.replace(encoded, page)
                                      : template.replace(token, page)
  }
}
